<template>
  <v-container
    @focusin="componentFocus"
    @blur="exit"
  >
    <v-row class="v-text-field no-gutters pa-0" dense>
      <label
        class="text--secondary v-label--active mb-n3"
        v-text="$t('fields.takeoff_type')"
      />
    </v-row>
    <v-row align="center" justify="center" style="margin: -12px">
      <v-btn-toggle
        ref="toggle"
        v-model="_takeoff_type"
        mandatory
        class="mt-2"
      >
        <v-tooltip
          v-for="(btn, i) in buttons"
          :key="i"
          bottom
        >
          <template v-slot:activator="{ on, attrs }">
            <v-btn
              :id="btn.value"
              ref="buttons"
              v-bind="attrs"
              :value="btn.value"
              :tooltip="btn.toolTip"
              width="auto"
              color="primary"
              small
              v-on="on"
              @keydown="keyDown"
              @blur="blur"
            >
              {{ btn.text }}
            </v-btn>
          </template>
          <span>{{ $t(btn.toolTip) }}</span>
        </v-tooltip>
      </v-btn-toggle>
    </v-row>
  </v-container>
</template>

<script>
  export default {
    name: 'GliderTakeoffType',
    model: {
      prop: 'takeoffType',
      event: 'selectedchange',
    },
    props: {
      takeoffType: String,
    },
    data () {
      return {
        buttons: [
          { value: 'tof_03', toolTip: this.$t('fields.takeoff_type_3'), text: 'CS' },
          { value: 'tof_02', toolTip: this.$t('fields.takeoff_type_2'), text: 'V' },
          { value: 'tof_01', toolTip: this.$t('fields.takeoff_type_1'), text: 'Ö' },
          { value: 'tof_04', toolTip: this.$t('fields.takeoff_type_4'), text: 'G' },
          { value: 'tof_05', toolTip: this.$t('fields.takeoff_type_5'), text: 'A' },
        ],
        focused: false,
      }
    },
    computed: {
      currentIdx () { return this.buttons.indexOf(this.buttons.find(B => B.value === this.takeoffType)) },
      _takeoff_type: {
        get: function () {
          return String(this.takeoffType)
        },
        set: function (value) {
          // this.$emit('selectedchange', Number(value))
          this.$emit('selectedchange', value)
          this.$nextTick(() => {
            this.focusSync()
          })
        },
      },
    },
    methods: {
      keyDown (e) {
        // console.log('keydown: ' + e.keyCode)
        if (e.keyCode === 39) {
          const nextIdx = this.currentIdx < 4 ? this.currentIdx + 1 : 0
          this._takeoff_type = this.buttons[nextIdx].value
          this.$nextTick(() => {
            this.$refs.buttons[nextIdx].$el.focus()
          })
          return
        } else if (e.keyCode === 37) {
          const nextIdx = this.currentIdx > 0 ? this.currentIdx - 1 : 4
          this._takeoff_type = this.buttons[nextIdx].value
          this.$nextTick(() => {
            this.$refs.buttons[nextIdx].$el.focus()
          })
          return
        } else if (e.keyCode === 9) {
          if (e.shiftKey) {
            this.leavePrevComponent()
          } else {
            this.leaveNextComponent()
          }
          return
        }
        e.preventDefault()
      },
      blur (e) {
        // this.focused = false
        // console.log('blur button')
        // console.log(e)
      },
      componentFocus (e) {
        if (e.target.value !== this._takeoff_type && !this.focused) {
          // console.log('Átugrás')
          this.focusSync()
        }
        this.focused = true
      },
      leaveNextComponent () {
        console.log('Next')
        this.$nextTick(() => {
          this.$refs.buttons[4].$el.focus()
          this.focused = false
        })
      },
      leavePrevComponent () {
        console.log('Prev')
        this.$nextTick(() => {
          this.$refs.buttons[0].$el.focus()
          this.focused = false
        })
      },
      focusSync () {
        this.$refs.buttons[this.currentIdx].$el.focus()
      },
      exit () {
        console.log('exit component')
      },
    },
  }
</script>
